// extracted by mini-css-extract-plugin
export default {"container":"animation-pop-module--container--07b62"};